<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row mx-0">
            <div class="col-md-12 col-12">
              <div class="col-md-12 mb-2 empl-tptxt"><h3>Company Settings</h3></div>
              <div class="col-md-12">
                <div class="my-5 vtabs1">
                  <div class="row">
                    <div class="col-md-3 col-sm-12 px-0">
                      <div class="d-flex align-items-start">
                        <div
                          class="nav flex-column nav-pills w-100"
                          id="v-pills-tab"
                          role="tablist"
                          aria-orientation="vertical">
                          <li
                            class="nav-link active"
                            id="v-pills-comms-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-comms"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-comms"
                            aria-selected="true">
                            Communication Preference
                          </li>
                          <li
                            class="nav-link"
                            id="v-pills-modules-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-modules"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-modules"
                            aria-selected="false">
                            Module Based Settings
                          </li>
                          <li
                            class="nav-link" *ngIf="isRmsUser"
                            id="v-pills-onboarding-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-onboarding"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-onboarding"
                            aria-selected="false">
                            Onboarding Settings
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9 col-12 main-tbscontdv pdng-addclntpg">
                      <div class="tab-content" id="v-pills-tabContent">
                        <!-- Communication tab -->
                        <div
                          class="tab-pane fade show active"
                          id="v-pills-comms"
                          role="tabpanel"
                          aria-labelledby="v-pills-comms-tab">
                          <form [formGroup]="communicationForm">
                            <div class="row">
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Email</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="antb"
                                      [formControlName]="EMAIL"
                                      [checked]="communicationForm.get(EMAIL)?.value"
                                      (change)="emailPreferenceSetting()" />
                                    <label for="antb"></label>
                                    <span>{{ communicationForm.get(EMAIL)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>SMS</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="eitb"
                                      [formControlName]="SMS"
                                      [checked]="communicationForm.get(SMS)?.value"
                                      (change)="smsPreferenceSetting()" />
                                    <label class="label-checked" for="eitb"></label>
                                    <span>{{ communicationForm.get(SMS)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Whatsapp</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="rdtb"
                                      [formControlName]="WHATSAPP"
                                      [checked]="communicationForm.get(WHATSAPP)?.value"
                                      (change)="whatsappPreferenceSetting()" />
                                    <label for="rdtb"></label>
                                    <span>{{ communicationForm.get(WHATSAPP).value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 text-end justify-content-end clientsetingpglst">
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="
                                    saveSettings(COMPANY_SETTINGS_TYPE.NOTIFICATION_PREFERENCES, this.communicationForm)
                                  ">
                                  SAVE
                                </button>
                                <button type="button" class="btn">DISCARD</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <!-- Modules tab -->
                        <div
                          class="tab-pane fade"
                          id="v-pills-modules"
                          role="tabpanel"
                          aria-labelledby="v-pills-modules-tab">
                          <form [formGroup]="moduleForm">
                            <div class="row">
                              <div class="col-12">
                                <div class="row">
                                  <div class="col-md-12">
                                    <h6 class="mb-3">Set Status for Each Module</h6>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Activity Tracker</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-antb"
                                      [formControlName]="ACTIVITY_TRACKER"
                                      [checked]="moduleForm.get(ACTIVITY_TRACKER)?.value" />
                                    <label for="mod-antb"></label>
                                    <span>{{ moduleForm.get(ACTIVITY_TRACKER)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Circular & Communication</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-detb"
                                      [formControlName]="CIRCULAR_AND_COMMUNICATION"
                                      [checked]="moduleForm.get(CIRCULAR_AND_COMMUNICATION)?.value" />
                                    <label for="mod-detb"></label>
                                    <span>{{
                                      moduleForm.get(CIRCULAR_AND_COMMUNICATION)?.value ? ENABLED : DISABLED
                                    }}</span>
                                  </div>
                                </div>
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Document Repository</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-fetb"
                                      [formControlName]="DOCUMENT_REPOSITORY"
                                      [checked]="moduleForm.get(DOCUMENT_REPOSITORY)?.value" />
                                    <label for="mod-fetb"></label>
                                    <span>{{ moduleForm.get(DOCUMENT_REPOSITORY)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Government Business Task</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-eitb"
                                      [formControlName]="GOVERNMENT_BUSINESS_TASK"
                                      [checked]="moduleForm.get(GOVERNMENT_BUSINESS_TASK)?.value" />
                                    <label for="mod-eitb"></label>
                                    <span>{{
                                      moduleForm.get(GOVERNMENT_BUSINESS_TASK)?.value ? ENABLED : DISABLED
                                    }}</span>
                                  </div>
                                </div>
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Dashboard</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-dutb"
                                      [formControlName]="DASHBOARD"
                                      [checked]="moduleForm.get(DASHBOARD)?.value" />
                                    <label for="mod-dutb"></label>
                                    <span>{{ moduleForm.get(DASHBOARD)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Queries</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-nutb"
                                      [formControlName]="QUERIES"
                                      [checked]="moduleForm.get(QUERIES)?.value" />
                                    <label for="mod-nutb"></label>
                                    <span>{{ moduleForm.get(QUERIES)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Calendar</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-rdtb"
                                      [formControlName]="CALENDAR"
                                      [checked]="moduleForm.get(CALENDAR)?.value" />
                                    <label for="mod-rdtb"></label>
                                    <span>{{ moduleForm.get(CALENDAR)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Knowledge Bank</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="mod-kdtb"
                                      [formControlName]="KNOWLEDGE_BANK"
                                      [checked]="moduleForm.get(KNOWLEDGE_BANK)?.value" />
                                    <label for="mod-kdtb"></label>
                                    <span>{{ moduleForm.get(KNOWLEDGE_BANK)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 text-end justify-content-end clientsetingpglst">
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="saveSettings(COMPANY_SETTINGS_TYPE.MODULES, this.moduleForm)">
                                  SAVE
                                </button>
                                <button type="button" class="btn">DISCARD</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <!--Onboarding settings-->
                        <div
                          class="tab-pane fade"
                          *ngIf="isRmsUser"
                          id="v-pills-onboarding"
                          role="tabpanel"
                          aria-labelledby="v-pills-onboarding-tab">

                          <div class="container onboarding-options">

                            <div class="col-md-12 mb-3 empl-tptxt">
                              <h3>Onboarding Settings</h3>
                              <p>Select an action to continue</p>
                            </div>

                            <div class="row row-cols-1 row-cols-md-2 g-3 mx-0">

                              <!-- Add New Company -->
                              <div class="col">
                                <div class="miangbdpg-boxxcont"
                                     [ngClass]="{ 'active-box': selection === 'new' }"
                                     (click)="selectMode('new')">

                                  <div class="col">
                                    <div class="p-5">
                                      <div class="empl-tptxt link">
                                        <h3>Add New Company</h3>
                                        <p>Start onboarding a new organization</p>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>

                              <!-- Edit Existing Company -->
                              <div class="col">
                                <div class="miangbdpg-boxxcont"
                                     [ngClass]="{ 'active-box': selection === 'existing' }">
                                  <!--(click)="selectMode('existing')"-->

                                  <div class="col">
                                    <div class="p-5">
                                      <div class="empl-tptxt link">
                                        <h3>Edit Existing Company</h3>
                                        <p>Update an already onboarded company</p>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>

                            </div>

                            <!-- Dropdown only for Edit mode -->
                            <div class="col-md-6 mt-4" *ngIf="selection === 'existing'">
                              <label class="form-label">Select Company</label>
                              <select class="form-select" [(ngModel)]="selectedCompany">
                                <option [ngValue]="null">-- Select --</option>
                                <option *ngFor="let c of companies" [ngValue]="c.id">
                                  {{ c.name }}
                                </option>
                              </select>
                            </div>

                            <!-- Proceed is only available for editing -->
                            <div class="mt-4" *ngIf="selection === 'existing'">
                              <button class="btn btn-primary"
                                      [disabled]="!selectedCompany"
                                      (click)="proceed()">
                                PROCEED
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
